import React, { useContext, useEffect, useState } from 'react'
import Container from 'components/container'
import Header from 'components/header'
import Footer from 'components/footer'
import styles from './contactus.module.scss'
import IframeResizer from 'iframe-resizer-react'
import { AppContext } from 'state'

import {
  Footer as FooterProp,
  Header as HeaderProp
} from 'state/types'



const ContactUsView: React.FC = () => {

  const { platesJson } = useContext(AppContext)
  const mainUrl = `${process.env.REACT_APP_DOT_SERVER_URL}`+platesJson.ContactUs?.url?.filename_url
  console.log('contact us dddd---',`${process.env.REACT_APP_DOT_SERVER_URL}`+platesJson.ContactUs?.url?.filename_url)
  const [footer, setFooter] = useState<FooterProp | null>(
    (platesJson.footer) || null
  )
  const [header, setHeader] = useState<HeaderProp | null>(
    (platesJson.header) || null
  )

  useEffect(() => {
    if (platesJson.footer) {
      console.log('main footer---',platesJson.footer.PrivacyPolicy_link)
      setFooter(platesJson.footer)
    }
    if (platesJson.header) {
      console.log('main header---',platesJson.header.FAQs_link)
      setHeader(platesJson.header)
    }
  }, [platesJson])
  return (
    <>
      <div style={{minHeight:window.innerHeight}}>
        <Container full className={styles.headerBg}>
          {/* <Container> */}
          {header && <Header {...header} />}
          {/* </Container> */}
        </Container>
          <IframeResizer
            //forwardRef={iframeRef}
            heightCalculationMethod="lowestElement"
            inPageLinks
            log
            //onMessage={onMessage}
            //onResized={onResized}
            src={mainUrl}
            style={{ width: '1px', minWidth: '100%', height: '160vh'}}
          />
        <Container full className={styles.footerBg}>
          {footer && <Footer {...footer} />}
        </Container>
      </div>
    </>
  )
}

export default ContactUsView
